<div class="price-tier-quad" role="list">
  <ng-container *ngFor="let slot of slots; trackBy: trackBySortOrder">
    <ng-container *ngIf="cellItem(slot.sortOrder) as item">
      <a
        *ngIf="cellLink(item) as link; else staticCard"
        class="price-tier-quad__card"
        [routerLink]="link"
        role="listitem"
      >
        <ng-container *ngTemplateOutlet="cardInner; context: { $implicit: item, slot: slot }"></ng-container>
      </a>
      <ng-template #staticCard>
        <div class="price-tier-quad__card" role="listitem">
          <ng-container *ngTemplateOutlet="cardInner; context: { $implicit: item, slot: slot }"></ng-container>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</div>

<ng-template #cardInner let-item let-slot="slot">
  <div class="price-tier-quad__glow" aria-hidden="true"></div>
  <div class="price-tier-quad__media-wrap">
    <img
      *ngIf="item.mediaType !== 'video'"
      class="price-tier-quad__media"
      [appMediaSrc]="item.mediaUrl"
      [appMediaProfile]="mediaProfileForSlot(slot)"
      [appMediaSlotHint]="slot.hintPx"
      [appMediaSizes]="sizesForSlot(slot)"
      [appMediaSharp]="true"
      [appMediaProgressive]="false"
      appMediaPlaceholder="/assets/placeholder.svg"
      [alt]="item.title || ''"
      loading="lazy"
    />
    <video
      *ngIf="item.mediaType === 'video'"
      class="price-tier-quad__media"
      [appMediaSrc]="item.mediaUrl"
      muted
      loop
      playsinline
      autoplay
    ></video>
  </div>
  <div class="price-tier-quad__copy">
    <span class="price-tier-quad__eyebrow">{{ item.badgeText || item.ctaText || ('promo.shop_now' | t) }}</span>
    <strong class="price-tier-quad__title">{{ item.title || ('promo.less_than' | t) }}</strong>
    <span class="price-tier-quad__price" *ngIf="item.description">{{ item.description }}</span>
  </div>
</ng-template>
